import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { ServicesHelper } from '../helpers/index';
import { VulnerableActivity, VulnerableActivityHistory } from '../models/index';

@Injectable()
export class VulnerableActivitiesService extends BaseService<VulnerableActivity> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string) {
    const url: string = apiUrl + 'vulnerable-activities/';
    super(apiUrl, url, httpClient);
  }

  getCurrentVulnerableActivity(): Observable<VulnerableActivity> {
    const url: string = this.url + 'current';
    const response: Observable<VulnerableActivity> = this.httpClient.get<VulnerableActivity>(url, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }
  getHistoryVulnerableActivity(vulnerableActivityId: string): Observable<VulnerableActivityHistory> {
    const url: string = this.url + 'history/' + vulnerableActivityId;
    const response: Observable<VulnerableActivityHistory> = this.httpClient.get<VulnerableActivityHistory>(url, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }
}
